// extracted by mini-css-extract-plugin
export default {"draftsContainer":"SongDrafts_draftsContainer__G6Nfi","draftSingleDiv":"SongDrafts_draftSingleDiv__c8c0x","separator":"SongDrafts_separator__sOP7z"};